import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormBuilder, FormControl, FormGroup } from '@angular/forms'

@Component({
    selector: 'overtur-monorepo-advanced-search',
    templateUrl: './advanced-search.component.html',
    styleUrls: ['./advanced-search.component.scss'],
    standalone: false
})
export class AdvancedSearchComponent {
  @Input() filterFormGroup: FormGroup
  @Input() filterControlNames: { control: string; label: string; maxLength?: number }[] = [{ control: 'none', label: 'none' }]

  @Output() focusSet = new EventEmitter<string>()

  constructor(public form: FormBuilder) {
    this.filterFormGroup = this.form?.group({ none: new FormControl() })
  }

  setSearchFocus(filterControlName: string) {
    this.focusSet.emit(filterControlName)
  }
}
